import React from "react";
import { Box, Button } from "@mui/material";

interface TabBarProps {
  selectedTab: "overview" | "frame" | "quality" | "guiding";
  setSelectedTab: (tab: "overview" | "frame" | "quality" | "guiding") => void;
}

const TabBar: React.FC<TabBarProps> = ({ selectedTab, setSelectedTab }) => (
  <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
    <Button
      variant={selectedTab === "overview" ? "contained" : "outlined"}
      color="primary"
      sx={{
        borderRadius: 2,
        fontWeight: 600,
        textTransform: "none",
        px: 3,
      }}
      onClick={() => setSelectedTab("overview")}
    >
      Overview
    </Button>
    <Button
      variant={selectedTab === "frame" ? "contained" : "outlined"}
      color="primary"
      sx={{
        borderRadius: 2,
        fontWeight: 600,
        textTransform: "none",
        px: 3,
      }}
      onClick={() => setSelectedTab("frame")}
    >
      Frame Details
    </Button>
    <Button
      variant={selectedTab === "quality" ? "contained" : "outlined"}
      color="primary"
      sx={{
        borderRadius: 2,
        fontWeight: 600,
        textTransform: "none",
        px: 3,
      }}
      onClick={() => setSelectedTab("quality")}
    >
      Quality Analysis
    </Button>
    <Button
      variant={selectedTab === "guiding" ? "contained" : "outlined"}
      color="primary"
      sx={{
        borderRadius: 2,
        fontWeight: 600,
        textTransform: "none",
        px: 3,
      }}
      onClick={() => setSelectedTab("guiding")}
    >
      Guiding
    </Button>
  </Box>
);

export default TabBar;
